// eslint-disable-next-line import/no-unresolved, import/no-webpack-loader-syntax
import LayoutWorker from "worker-loader!./LayoutWorker.worker";

export const createLayoutWorker = () => {
  const layoutWorker = new LayoutWorker();
  return layoutWorker;
};
